import { fetchAndCacheWithoutPage } from '@/components/shared/CacheStroage/CacheWithoutPage';

import { IResponse } from '@/utils/interfaces';
import { IBestsellerSpotlight } from '@/utils/interfaces/BestsellerSpotlight';

import { baseForPdf } from '../apiClients';
import { Endpoints } from '../../network';

export const getAllBestsellerSpotlight = async (): Promise<
  IResponse<IBestsellerSpotlight[]>
> => {
  const apiUrl = `${Endpoints.getAllBestsellerSpotlight}`;

  const apiCall = async () => {
    const response = await baseForPdf.get(apiUrl);
    return response?.data;
  };

  return fetchAndCacheWithoutPage(apiCall, apiUrl);
};
